require('./style.scss');

import LinearBlurFilter from './linearBlurFilter';
const detectBrowser = require('a_common-folder/utils/detectBrowser');

export default class EffectZoom {
    _container = null;
    _canvasEffect = null;
    _containerParams = null;
    _animationItteraction = 0;
    _axiosY = 0;
    _offsetX = 50;
    _canvasClass = 'zoom-effect';
    _blur = 2;
    _blur2 = 50;
    _opacityTime = 1;
    _countItteration = 20;
    _hide = null;

    constructor(container, {width, height, x, y}) {
        this._container = container;
        this._containerParams = {width, height};
        this.animationX = x;
        this.animationY = y;
    }

    runAnimation(callback) {
        let {width, height} = this._containerParams;

        if(!detectBrowser.isIE) this._canvasEffect.style.transformOrigin = `${~~this.animationX / width * 100}% ${~~this.animationY / height * 100}%`;

        this._canvasEffect.classList.add('scalling');

        callback && callback(this._opacityTime)

        setTimeout(() => this._removeCanvas(), this._opacityTime * 1000)
    }

    _removeCanvas() {
        this._container.removeChild(this._canvasEffect);
    }

    _hideCanvas() {
        this._canvasEffect.style.opacity = 0;
    }

    _createCanvas() {
        const {width, height} = this._containerParams;

        const canvas = document.createElement('canvas');
        canvas.style.position = 'absolute';
        canvas.style.top = 0;
        canvas.style.left = 0;
        canvas.width = width;
        canvas.height = height;
        canvas.style.width = width;
        canvas.style.height = height;
        canvas.style.zIndex = 999999;
        canvas.style.transform = 'scale(1)';
        canvas.style.transition = `all 2s ease-in-out`;
        canvas.classList.add(this._canvasClass);

        return canvas;
    }

    _addLinearBlurFilter() {
        const filterEffect = new LinearBlurFilter();
        filterEffect.blur = this._blur;
        filterEffect.blur2 = this._blur2;
        const {width, height} = this._containerParams;
        filterEffect.p1.x = width;
        filterEffect.p1.y = 0;
        filterEffect.p0 = {x: this.animationX, y: this.animationY};
        return filterEffect;
    }

    addCanvas(dataUrl, callback) {
        const canvas = this._createCanvas();

        const img = document.createElement('img');
        img.addEventListener('load', () => {
            this._animationImg = img;
            const filterEffect = this._addLinearBlurFilter();
            filterEffect.convertImage(canvas, img);
            this._container.appendChild(canvas);
            this._canvasEffect = canvas;

            callback(canvas);
        });

        img.src = dataUrl;
    }
}

